import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
  {
    apiUrl: "/video",

    async list({ name, page }) {
      const url = this.url();

      const query = {
        name,
        page,
      };

      return Vue.http.get(url, {
        params: query,
      });
    },

    async getUploadURL(name) {
      const url = this.url();

      return Vue.http.post(url, null, {
        params: {
          name,
        },
      });
    },

    async upload({ url, formData }) {
      return Vue.http.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-Skip-Auth": true,
        },
      });
    },

    async delete(id) {
      const url = this.url(`/${id}`);

      return Vue.http.delete(url);
    },
  },
  base
);
